<div class="header-navbar">
    <div class="mobile-menu-btn">
        <em (click)="openMenu()" class="pi pi-bars"></em>
    </div>
    <div class="landing-container">
        <div class="grid">
            <div class="col-3 sm:col-2">
                <div class="logo-outer">
                    <a *ngIf="(presentComponent === 1 || presentComponent === 2); else homeLink" href="/">
                        <img src="assets/images/landing-page/truck-whitelogo.svg" alt="logo" class="img-fluid" />
                    </a>
                    <ng-template #homeLink>
                        <img [ngClass]="{'cursor-pointer':presentComponent === 3}" routerLink="/"
                            src="assets/images/landing-page/truck-whites-logo.svg" alt="logo" class="img-fluid" />
                    </ng-template>
                </div>
            </div>
            <div class="col-9 sm:col-10">
                <div class="menu-box">

                    <ul *ngIf="toggleMenu" class="nav-lists main_list mob-nav-list"
                        [ngClass]="{'show_list' : isClicked}" id="mainListDiv">
                        <div class="mobile-menu-btn"> <em (click)="closeMenu()" class="pi pi-times"></em></div>
                        <li class="nav-items active-menu">
                            <a routerLink="/" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" [class.cl-b]="presentComponent=== 1 || presentComponent===2"  [routerLinkActive]="'active'">
                                Home
                            </a>
                        </li>
                        <li class="nav-items active-menu">
                            <a class="nav-link" 
                                [class.cl-b]="presentComponent === 1 || presentComponent === 2" 
                                [class.active]="activeClass" 
                                (click)="redirectToServices()"  [routerLinkActive]="'active'">
                                Our services
                            </a>
                        </li>
                        <li class="nav-items  truck-operators">
                            <a class="nav-link"
                                [ngClass]="{'active':isRouteActive(),'cl-b':presentComponent=== 1 || presentComponent===2}"
                                (click)="clickMenu($event)">
                                <span>Book Truck Parking</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4"
                                    fill="none">
                                    <path d="M7.5 0L3.75 3.75L0 6.55671e-07L7.5 0Z"
                                        [attr.fill]="presentComponent === 1 ? '#1D4ED8' : (presentComponent === 2 ? 'black' : 'white')" />

                                </svg>

                            </a>
                            <div *ngIf="isClicked" #menu class="truck-outer">
                                <ul>
                                    <li routerLinkActive="menu-active">
                                        <a routerLink="/truck-driver"  [class.cl-b]="presentComponent=== 1 || presentComponent===2">
                                            <img src="../../assets/images/individual-driver1.png"
                                                alt="Individual Driver" />
                                            <h4>Book One Spot</h4> 
                                        </a>
                                    </li>
                                    <li routerLinkActive="menu-active" [class.cl-b]="presentComponent=== 1 || presentComponent===2">
                                        <a routerLink="/group-operator">
                                            <img src="../../assets/images/group-booking-operator2.png"
                                                alt="Group Booking Operator" />
                                            <h4>Book Multiple Spots</h4>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li class="nav-items" routerLink="/parking-lot-manager">
                            <a class="nav-link " [class.cl-b]="presentComponent===1 || presentComponent===2"
                                [routerLinkActive]="'active'">
                                Parking lot managers
                            </a>
                        </li>
                        <li class="nav-items">
                            <a routerLink="/help-desk" class="nav-link"
                                [class.cl-b]="presentComponent===1 || presentComponent===2"  [routerLinkActive]="'active'">
                                help Center
                            </a>
                        </li>
                    </ul>

                </div>
            </div>
        </div>

    </div>
</div>
